"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CamundaExtensionProperty = void 0;
/**
 * Describes a single Camunda specific ExtensionProperty.
 * These are wrapped in the <camunda:property></camunda:property> tag.
 */
class CamundaExtensionProperty {
}
exports.CamundaExtensionProperty = CamundaExtensionProperty;
//# sourceMappingURL=CamundaExtensionProperty.js.map